// extracted by mini-css-extract-plugin
export default {"backgroundImg":"JP_SocialResponsibility_backgroundImg__XRGy1"};